// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hs-0";